// extracted by mini-css-extract-plugin
export default {"base":"RadioButton_base__PyL0J","disabled":"RadioButton_disabled__3mvTS"};